/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import DashboardFrontCard from "../../../components/Layouts/FleetDistanceInsightsCard/DashboardFrontCard";
import {AppHeatMap}  from "../../../components/Layouts/GoogleHeatMap/HeatMaps";
import { ZyppLiteApi } from "../../../API/Zypp-Lite-Api/LiteApi";


const FleetDistanceInsights = () => {
const [overviewDetailData, setOverviewDetailData] =  useState<any>();


useEffect(() => {
    ZyppLiteApi.api?.overviewDeatailData()
      .then((response) => {
        if (response?.code === 2000) {
        
          setOverviewDetailData(response.data);
        } else {
          setOverviewDetailData([]);
        }
      })
      .catch((error) => {
        console.error("API call error: ", error);
      });
  }, []);
  
  return (
    <>
     <div className="flex ml-4">
                <h2 className="text-center ml-2 mx-1 mt-2 font-semibold text-2xl text-black pb-2">
                OverView
                </h2>
              </div>
      <div className=" font-rubik text-sm p-10">
       
        <div className="flex relative bottom-8">
          
          <div className="w-full	 flex flex-wrap animate__animated animate__fadeInLeft">
            <div className="w-full flex">
              <DashboardFrontCard
                textFirstLine="Total Carbon saved"
                clientData={overviewDetailData?.totalCarbonSaved}
                imageURL="/assets/carbon.svg"
                lineImageURL="/assets/green-line.svg"
                totalData={0}
              ></DashboardFrontCard>

              <DashboardFrontCard
                textFirstLine="Total Tree Saved"
                totalData={0}
                clientData={overviewDetailData?.totalTreesSaved}
                imageURL="/assets/tree.svg"
                lineImageURL="/assets/green-line.svg"
              ></DashboardFrontCard>
              <DashboardFrontCard
                textFirstLine="Total Live EV"
                totalData={0}
                clientData={overviewDetailData?.totalLiveEV}
                imageURL="/assets/ev.svg"
                lineImageURL="/assets/blue-line.svg"
              ></DashboardFrontCard>
            </div>
           
          </div>
        </div>
        {/* { Creating second div elements for card view } */}

        <div className="flex-grow w-full bg-[#fff]  font-rubik relative box-shadow  rounded-xl">
          <div className="flex justify-between items-center border-b pt-3">
            <div>
              <h2 className="text-center mx-1 mt-1 font-bold ml-5 text-base text-[#263238] pb-2">
                Heat Map
              </h2>
            </div>
            
          </div>

          <div style={{ width: "100%", height: "19.5rem", padding:"20px" }}>
            <AppHeatMap />
          </div>
        </div>
<div className="w-full mt-3">
        <h3 className="text-center mb-3">© 2025 Powered by Zypp Electric</h3>
        </div>
      </div>
    </>
  );
};

export default FleetDistanceInsights;
